export default "__VITE_ASSET__BcQYS9Mr__"